module.exports = __webpack_public_path__ + "static/media/edit.fbdcc24a.svg";